"use client";

import { Countdown } from "@/components/countdown";
import { NavBar } from "@/components/nav-bar";
import VoteList from "./vote-list";
import Image from "next/image";
import InfoBanner from "./info-banner";
import { motion } from "framer-motion";
import { useFetchTokenData } from "@/hooks/useFetchTokenData";
import { TotalVoteCount } from "./totalVoteCount";
import AnimatedHeading from "../ui/animatedHeading";
import { useCatDev } from "@/context/catdevContext";
// const headingText = {
//   line: "is on an eternal search",
//   line2: "for the best cat meme in existence.",
// };

export default function Vote() {
  // to fetch token data
  useFetchTokenData();
  const { votingData } = useCatDev();

  const totalVotes = votingData.reduce((acc, item) => acc + item.vote, 0);

  return (
    <main className="min-h-screen relative overflow-hidden bg-[url('/assests/bg-lines.jpg')] bg-repeat font-lato">
      {/* Content */}
      <NavBar />
      {/* <HeroSection/> */}
      <div className="relative z-10 min-h-screen flex flex-col justify-center items-center ">
        {/* Background Video */}
        <video
          autoPlay
          loop
          muted
          playsInline
          className="absolute inset-0 z-0 w-full h-full object-cover"
        >
          <source src="/mountains.mp4" type="video/mp4" />
        </video>
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-black opacity-10 z-0"></div>

        <div className="relative w-full h-full mx-auto z-10 my-auto px-4 sm:py-12 py-18">
          {/* Cat Images */}
          <Image
            src="/assests/cat_top_left.png"
            alt="Decorative cat"
            width={200}
            height={200}
            className="animate-floattopleft w-11 h-11 lg:w-auto md:h-auto absolute top-2 left-2 md:left-20"
          />
          <Image
            src="/assests/cat_top_right.png"
            alt="Decorative cat"
            width={200}
            height={200}
            className="animate-floattopright w-11 h-11 lg:w-auto md:h-auto absolute top-2 right-2 md:right-20"
          />
          <Image
            src="/assests/cat_bottom_left.png"
            alt="Decorative cat"
            width={200}
            height={200}
            className="animate-floatbottomleft w-11 h-11 lg:w-auto md:h-auto absolute bottom-2 left-2 md:left-20"
          />
          <Image
            src="/assests/cat_bottom_right.png"
            alt="Decorative cat"
            width={200}
            height={200}
            className="animate-floatbottomright w-11 h-11 lg:w-auto md:h-auto absolute bottom-2 right-2 md:right-20"
          />

          {/* Main Content */}

          <div className="flex flex-col justify-center items-center text-center mb-6 mt-16 md:mt-12">
            <AnimatedHeading
              as="h1"
              delayStep={0.1}
              duration={0.6}
              splitText
              className="w-full lg:max-w-screen-sm my-4 md:text-3xl"
              aria-label="CATDEV Together we will build Artificial Super Catteligence"
            >
              CATDEV is on an eternal search for the best cat meme in existence
            </AnimatedHeading>

            <Countdown />
          </div>
          <InfoBanner message="Every hour, a new cat meme evolves from the collective wisdom of our community" />
          {/* Shop Now Button */}

          <div className="flex flex-col items-center justify-center mt-4 mx-auto h-auto max-w-screen-xl xl:px-20">
            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3, delay:0.2 }}
              className="relative w-full max-w-2xl"
            >
              {" "}
              <TotalVoteCount
                votes={totalVotes}
                maxVotes={totalVotes > 0 ? totalVotes * 1.5 : 60}
              />
            </motion.div>
            {/* <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.3 }}
            
            >
              <Image
                width={1800}
                height={1800}
                src={"/assests/desktop-vote-ui.png"}
                alt="voting ui"
                className=" hidden md:flex h-full w-auto object-cover"
                priority
              />
              <Image
                width={900}
                height={900}
                src={"/assests/mobile-vote-ui.png"}
                alt="voting ui"
                className="md:hidden"
                priority
              />
            </motion.div> */}
            {/* <div className=" text-center my-3">
              <Link
                href="/vote#votelist"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .getElementById("votelist")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
              >
                <Button
                  variant={"outline"}
                  size="lg"
                  className="border-white border bg-transparent hover:bg-indigo-500  rounded-xl text-white hover:text-white text-lg px-8 py-6  shadow-lg hover:shadow-xl transition-all duration-300 transform hover:-translate-y-1  gap-5"
                >
                  <span>Explore Now</span>
                  <ArrowDown className="animate-bounce" />
                </Button>
              </Link>
            </div> */}
          </div>
        </div>
      </div>

      <VoteList />
    </main>
  );
}
